import { useState, useRef, useEffect } from 'react';
import './Menu.css';

const Menu = ({ scrollbar }) => {
	const [isOpened, setIsOpened] = useState(false);
	const menuElement = useRef(null);
	const menuWrapperElement = useRef(null);

	const openMenu = () => {
		setIsOpened(true);
		menuElement.current.style.display = 'unset';
		setTimeout(() => {
			menuElement.current.style.opacity = '1';
			menuWrapperElement.current.style.transform = 'translateX(0%)';
			menuWrapperElement.current.style.width = '50%';
		}, 1);
	};

	const closeMenu = () => {
		setIsOpened(false);
		menuWrapperElement.current.style.transform = 'translateX(100%)';
		menuWrapperElement.current.style.width = 'calc(50% - 800px)';
		menuElement.current.style.opacity = '0';
		setTimeout(() => {
			menuElement.current.style.display = 'none';
		}, 500);
	};

	const scrollToElement = (positionY) => {
		scrollbar.scrollTo(0, positionY, 1000);
		closeMenu();
	};

	const initializeMenu = () => {
		const menuButton = document.querySelector('.open-close-menu ');

		if (scrollbar) {
			scrollbar.addListener(({ offset }) => {
				menuButton.style.top = offset.y + 75 + 'px';
				menuButton.style.right = offset.x + 75 + 'px';
				menuElement.current.style.top = offset.y + 'px';
				menuElement.current.style.left = offset.x + 'px';
			});
		}
	};

	useEffect(() => {
		initializeMenu();
	}, [scrollbar]);

	return (
		<>
			<button
				className={isOpened ? 'open-close-menu closed' : 'open-close-menu opened'}
				onClick={() => {
					if (isOpened) {
						closeMenu();
					} else {
						openMenu();
					}
				}}
			>
				<div className="line"></div>
				<div className="line"></div>
			</button>
			<div ref={menuElement} className="menu">
				<div ref={menuWrapperElement} className="menu-wrapper">
					<div className="left-side">
						<p>Media</p>
						<div className="options">
							<button>
								Instagram<div className="line"></div>
							</button>
							<button>
								Linkedin<div className="line"></div>
							</button>
							<button>
								Behance<div className="line"></div>
							</button>
							<button>
								Dribble<div className="line"></div>
							</button>
						</div>
					</div>
					<div className="right-side">
						<p>Nawigacja</p>
						<div className="options">
							<button onClick={() => scrollToElement(0)}>
								HOME<div className="line"></div>
							</button>
							<button onClick={() => scrollToElement(1135)}>
								PORTFOLIO<div className="line"></div>
							</button>
							<button onClick={() => scrollToElement(1000000000)}>
								KONTAKT<div className="line"></div>
							</button>
						</div>
					</div>
					<div className="contact-information">
						<p>Skontaktuj sie ze mna</p>
						<p>info@markokaczorowski.pl</p>
						<p>tel. 783 249 727</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default Menu;
